import * as React from 'react';
import { connect } from 'react-redux';
import { Accordion, Card, Image } from 'react-bootstrap';
import './EmergencyAssist.css';
import { DASHBOARD } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { NAM_COUNTRY_ID_NUMBER } from '../../constants/internationalization';
import FAQItem from '../FAQ/FAQItem';

class EmergencyAssist extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            accordionFAQActiveKey: -1,
        }
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
    }

    handleAccordianArrow(e: any) {
        this.setState({ accordionFAQActiveKey: e })
    }

    render() {

        let faqSetAccident = [{
            header: "In the event of an accident, we can assist with",
            body: `<p class='mb-0'><ul>
                                        <li> Arrangements for your car to be towed to a King Price- preferred place of repair.</li>
                                        <li>Arrangements for transport back home or to your place of work, for the driver and passengers.</li>
                                   </ul>
                                   </p>`,
            id: 1
        },
        {
            header: "What's NOT covered by the king's roadside or accident assist",
            body: `<p class='mb-0'><ul>
                                        <li>Cars not listed and insured on your King Price policy schedule.</li>
                                        <li>The cost of any parts that may be needed for repairs, such as batteries, tyres, lubricants, keys, locks, etc.</li>
                                        <li>The cost of any petrol that we may need to bring to you.</li>
                                        <li>Towing or repairs that aren't booked via the king's emergency assist line.</li>
                                        <li>Commercial cars used for business or trade.</li>
                                        <li>Non-registered or unroadworthy cars.</li>
                                        <li>Recovery of the car if extra help is needed to move it to an easier place to be towed from.</li>
                                    </ul></p>`,
            id: 2
        },
        ];

        let faqAccident;
        if (faqSetAccident) {
            faqAccident = faqSetAccident.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={this.state.accordionFAQActiveKey} />
                }
            });
        }

        let faqSetRoadside = [{
            header: "Breakdown... Mechanical or electrical",
            body: `<p class='mb-0'>1 of the king's hand-picked towing operators will tow your car or trailer or motorbike to the nearest approved place for repair or safekeeping.
                                   </p>`,
            id: 3
        },
        {
            header: "Flat tyre... Feeling a little let down",
            body: `<p class='mb-0'>You're covered for the labour cost of the tyre change… At roadside and non-roadside locations.</p>`,
            id: 4
            },
            {
                header: "Run out of petrol... Left high and dry",
                body: `<p class='mb-0'>10l of petrol will be delivered to you as soon as we can. The cost of the petrol is for your own account.</p>`,
                id: 5
            },
            {
                header: "Flat battery... There's just no spark",
                body: `<p class='mb-0'>We'll be there in a flash to jump-start your car and get you on the road again.</p>`,
                id: 6
            },
            {
                header: "Keys locked in your car... A locksmith is on his way",
                body: `<p class='mb-0'>Our locksmith will be on his way soonest and you can rest assured that you're covered for the first hour's labour.</p>`,
                id: 7
            },
            {
                header: "Remote assistance... Broken down and your home is nowhere in sight",
                body: `<p class='mb-0'>In an event of a breakdown more than 100km from your home, you're covered for 1 of the following:</p>
                                        </br>
                                        <ul>
                                            <li>Accommodation for the night.</li>
                                            <li>Taxi service to give you a lift home.</li>
                                            <li>Rental of a group B rental car, subject to a few T’s and C’s. Refer to your <a href="/Content/documents/King-price-insurance-policy.pdf" target="_blank">KPPD</a> for more info.</li>
                                        </ul></p>`,
                id: 8
            },
        ];

        let faqRoadside;
        if (faqSetRoadside) {
            faqRoadside = faqSetRoadside.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={this.state.accordionFAQActiveKey} />
                }
            });
        }

        let faqSetMedical = [{
            header: "Need medical care... We'll be there",
            body: `<p class='mb-0'>If you need emergency medical care, we'll pay to have you transferred to the nearest hospital as quickly as humanly possible.</p>`,
            id: 9
        },
        {
            header: "Further medical transportation... Doing what's best for you",
            body: `<p class='mb-0'>If the treating doctors or medical assistance directors recommend that you be transferred to a different hospital, then we'll cover that too.</p>`,
            id: 10
            },
            {
                header: "Hospitalization... Bringing you closer to home",
                body: `<p class='mb-0'>We'll transport you to a hospital closer to home, if the current hospital doesn't have the facilities to do so,
                                        within 24 hours of the accident occurring. This can only be done if your medical condition permits it,
                                        or if your treating doctor advises that longer hospitalisation is required.</p>`,
                id: 11
            },
            {
                header: "What's NOT covered by the king's medical assist",
                body: `<p class='mb-0'><ul>
                                        <li>When the emergency isn't medically justified and can adequately be treated at, or near, the place where the injury occurred.</li>
                                        <li>If you're able to travel as a seated passenger in any form of transport, without needing a medical escort.</li>
                                        <li>If you need medical care as a result of you intentionally trying to commit suicide, and/or if you participated in any criminal activity.</li>
                                      </ul></p>`,
                id: 12
            },
        ];

        let faqMedical;
        if (faqSetMedical) {
            faqMedical = faqSetMedical.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={this.state.accordionFAQActiveKey} />
                }
            });
        }

        let faqSetNam = [{
            header: "Breakdown... Mechanical or electrical",
            body: `<p class='mb-0'>1 of the king's hand-picked towing operators will tow your car or trailer or motorbike to the nearest approved place for repair or safekeeping.</p>`,
            id: 14
        },
        {
            header: "Flat tyre... Feeling a little let down",
            body: `<p class='mb-0'>You're covered for the labour cost of the tyre change… At roadside and non-roadside locations.</p>`,
            id: 15
        },
        {
            header: "Run out of petrol... Left high and dry",
            body: `<p class='mb-0'>10l of petrol will be delivered to you as soon as we can. The cost of the petrol is for your own account.</p>`,
            id: 16
        },
        {
            header: "Flat battery... There's just no spark",
            body: `<p class='mb-0'>We'll be there in a flash to jump-start your car and get you on the road again.</p>`,
            id: 17
        },
        {
            header: "Keys locked in your car... A locksmith is on his way",
            body: `<p class='mb-0'>Our locksmith will be on his way soonest and you can rest assured that you're covered for the first hour's labour.</p>`,
            id: 18
        },
        {
            header: "Remote assistance... Broken down and your home is nowhere in sight",
            body: `<p class='mb-0'>In an event of a breakdown more than 100km from your home, you're covered for 1 of the following:</p>
                                    <br/>
                                    <p>
                                    <ul>
                                        <li>Accommodation for the night.</li>
                                        <li>Taxi service to give you a lift home.</li>
                                        <li>Rental of a group B rental car, subject to a few T’s and C’s. Refer to your <a href="/Content/documents/King-price-insurance-policy.pdf" target="_blank">KPPD</a> for more info.</li>
                                    </ul></p>`,
            id: 19
        },
        ];

        let faqNam;
        if (faqSetNam) {
            faqNam = faqSetNam.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={this.state.accordionFAQActiveKey} />
                }
            });
        }

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]
        let country = (this.props.profile.countryId === 244) ? "SA" : "Namibia";
        return (
            <div id="Emergency_Assist" >
                <KPBreadCrumb navList={BreadcrumbDetails} activePage={this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? 'Emergency assist' : 'Roadside assist'} />
                <div>
                    <div className="row">
                        <div className="col-lg-6 col-sm-12 col-12  px-lg-3 mb-4">
                            <div className="EmergencyAssist p-3 pl-3">
                                <h3 className="mb-1">The king's {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? 'emergency' : 'roadside'} assist</h3>
                                <p>Your own royal guard is just a call away</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12 col-12  px-lg-3 mb-4">
                            <div className="Call p-3 pl-3">
                                <p>Call the number below for emergency assistance:</p>
                                <a href={"tel:" + this.props.ssp.contactUs_tel} target="_blank">
                                    <div className="input-group mt-2 mb-1">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><Image title="" alt="" src="./images/ContactUs/phone.svg" /></span>
                                        </div>
                                        <input type="text" className="pl-3 phoneNumber" disabled value={this.props.ssp.contactUs_tel} />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="Line d-block d-md-block d-lg-none mt-0" />
                    {this.props.profile.countryId !== 157 && <div className="row">
                        <div className="col-lg-6 col-sm-12 col-12  px-lg-3 mb-4">
                            <div className="AccidentAssist Assist p-3">
                                <h3>Accident assist</h3>
                                <p>All King Price comprehensive and theft and write-off policyholders have automatic accident assist cover. Remember to call our emergency assist line after an accident, and we’ll take over for you. If you’re not able to call us, please have someone do so as soon as possible.</p>
                                <div className="mb-2">
                                    <div className="col-12 col-lg nopa mobile-ml-0px">
                                        <Card className="policyDetailsCodeRed ">
                                            <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                                <Accordion onSelect={(e) => this.handleAccordianArrow(Number(e))}>
                                                    {faqAccident}
                                                </Accordion>
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12 col-12  px-lg-3 mb-4">
                            <div className="HomeAssist Assist p-3">
                                <h3>Home assist</h3>
                                <p>We take pride in our royal treatment. So, if you're a home contents or buildings insurance client you qualify for the following assistance with household or outbuildings emergencies. This type of assistance is limited to 3 incidents per year, per insured address that's stated on your King Price policy schedule. So, try to be careful! The cover includes the call-out fee and 1 hour's labour.</p>
                                <div className="mb-4">
                                    <p>Help is just a phone call away. Call us to arrange the services of:</p>
                                    <div className="row">
                                        <div className="col-lg-4 col-12 mb-2 new-benefits-col">
                                            <div className="icon-checkmark-circle"></div>&nbsp;
                                            Plumbers
                                        </div>
                                        <div className="col-lg-4 col-12 mb-2 new-benefits-col">
                                            <div className="icon-checkmark-circle"></div>&nbsp;
                                            Electricians
                                        </div>
                                        <div className="col-lg-4 col-12 mb-2 new-benefits-col">
                                            <div className="icon-checkmark-circle"></div>&nbsp;
                                            Locksmiths
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {this.props.profile.countryId !== 157 && <div className="row">
                        <div className="col-lg-6 col-sm-12 col-12  px-lg-3 mb-4">
                            <div className="RoadAssist Assist p-3">
                                <h3>Roadside assist</h3>
                                <p>King Price comprehensive car insurance clients qualify for the following emergency roadside assistance within {country} borders. This type of assistance is limited to 3 incidents per year, per car that's stated on your policy schedule.</p>
                                <div className="mb-4">
                                    <Card className="policyDetailsCodeRed ">
                                        <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                            <Accordion onSelect={(e) => this.handleAccordianArrow(Number(e))}>
                                                {faqRoadside}
                                            </Accordion>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12 col-12  px-lg-3 mb-4">
                            <div className="MedicalAssist Assist p-3">
                                <h3>Medical assist</h3>
                                <p>Your safety is our concern, always. After an accident, King Price comprehensive car insurance clients are entitled to any of the following medical assistance services. These are completely free, as long as the accident occurs within {country} borders.</p>
                                <div className="mb-2">
                                    <Card className="policyDetailsCodeRed ">
                                        <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                            <Accordion onSelect={(e) => this.handleAccordianArrow(Number(e))}>
                                                {faqMedical}
                                            </Accordion>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {this.props.profile.countryId !== 244 &&
                        <div className="row">
                            <div className="col-lg-6 col-sm-12 col-12  px-lg-3 mb-4">
                                <div className="RoadAssist Assist p-3">
                                    <h3>Roadside assist</h3>
                                    <p>King Price comprehensive car insurance clients qualify for the following emergency roadside assistance within {country} borders. This type of assistance is limited to 3 incidents per year, per car that's stated on your policy schedule.</p>
                                    <div className="mb-4">
                                        <Card className="policyDetailsCodeRed ">
                                            <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                                <Accordion onSelect={(e) => this.handleAccordianArrow(Number(e))}>
                                                    {faqNam}
                                                </Accordion>
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        ssp: state.ssp,
    }
}
export default connect(mapStateToProps)(EmergencyAssist);